import { render, staticRenderFns } from "./PreguntarCambiosModal.vue?vue&type=template&id=4e86d376&"
import script from "./PreguntarCambiosModal.vue?vue&type=script&lang=js&"
export * from "./PreguntarCambiosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports